import { Col, SelectField } from '@/components';
import { useCurrentFiscalYear } from '@/features/search/_hooks/get-current-fiscal-year';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { handleFundSheetTypeChange } from '@/features/search/_utils/project-form-control';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { FundSheetTypeLabelModifier, fundSheetTypeEnum } from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

const options = fundSheetTypeEnum.options.map((value) => ({
  value,
  label: FundSheetTypeLabelModifier[value],
}));

export const FundSheetTypeColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<ProjectSearchFormType>();
  const currentFiscalYear = useCurrentFiscalYear();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });

  if (sheetType !== 'KS') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="fundSheetType"
        label={t('fund-sheet-type')}
        control={control}
        errors={errors}
        allowClear={false}
        shouldCoexistOnChange
        onChange={(v) => {
          const value = v as z.infer<typeof fundSheetTypeEnum>;
          handleFundSheetTypeChange(
            value,
            setValue,
            currentFiscalYear.data ?? currentFiscalYear.basicFiscalYear,
          );
        }}
        options={options}
      />
    </Col>
  );
});
